// Drawola Studio — "Weekly planner" built-in template. Fork-only.
//
// Seven day columns: a tinted header block carrying the day name (bound text,
// so renaming a day is a double-click) above an empty body block to drop notes
// and stickies into. Weekend headers are tinted differently.

import { convertToExcalidrawElements } from "@excalidraw/excalidraw";

import type { ExcalidrawElementSkeleton } from "@excalidraw/element/transform";

import { FILL, templateAppState } from "./shared";

import type { TemplateScene } from "./types";

const X = 120;
const TITLE_Y = 92;
const HEADER_Y = 150;
const HEADER_H = 44;
const BODY_H = 300;
const COL_W = 120;
const COL_GAP = 8;

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const;

export const buildWeeklyPlannerTemplate = (): TemplateScene => {
  const columns = DAYS.flatMap((day, i): ExcalidrawElementSkeleton[] => {
    const x = X + i * (COL_W + COL_GAP);
    const isWeekend = i >= 5;
    return [
      {
        type: "rectangle",
        x,
        y: HEADER_Y,
        width: COL_W,
        height: HEADER_H,
        backgroundColor: isWeekend ? FILL.YELLOW : FILL.BLUE,
        label: { text: day, fontSize: 16 },
      },
      {
        type: "rectangle",
        x,
        y: HEADER_Y + HEADER_H,
        width: COL_W,
        height: BODY_H,
        backgroundColor: FILL.TRANSPARENT,
      },
    ];
  });

  const skeleton: ExcalidrawElementSkeleton[] = [
    {
      type: "text",
      x: X,
      y: TITLE_Y,
      text: "Week of ...",
      fontSize: 28,
    },
    ...columns,
  ];

  return {
    elements: convertToExcalidrawElements(skeleton),
    appState: templateAppState(),
  };
};
